// Copyright 2021 Carnegie Mellon University. All Rights Reserved.
// Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.

import { Directive } from '@angular/core';

@Directive({
    selector: '[cwdTableAction]',
    standalone: false
})
export class TableActionDirective {
  constructor() {}
}
